import React, { ReactElement } from 'react'
import { Questions as StyledQuestions } from './styled-components'

import InputRadio from '../../../../../../input/radio'

interface QuizTickProps {
  id: string
  correctAnswers: string[]
  answers: string[]
  onValueChange: (value: string) => void
}

function QuizTrueFalse({
  correctAnswers,
  answers,
  id,
  onValueChange,
}: QuizTickProps): ReactElement {
  return (
    <StyledQuestions>
      <InputRadio
        correctAnswers={correctAnswers}
        answers={answers}
        id={id}
        onValueChange={(e) => {
          onValueChange(e.target.value)
        }}
      />
    </StyledQuestions>
  )
}

export default QuizTrueFalse
